import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="disappear"
export default class extends Controller {
  connect() {
    setTimeout(() => this.element.classList.add("h-0", "opacity-0"), 18000);
    setTimeout(() => this.element.remove(), 18100);
  }
}
